import { React, useState, useEffect } from 'react'
import { json, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { formatDOSDate } from '../../utilities/Constants';
import { APIConstants, PatientDMTabConstants, CommonAPIConstants } from '../../utilities/Constants';
import { format } from 'date-fns';
import DatePicker from 'react-datepicker';
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AppointmentSection from '../AppointmentSection';
import { setDemoGraphyData } from '../../redux/actions/userActions';

const PatPersonalInfo = () => {
    const dispatch = useDispatch();
    const DemoGraphyData = useSelector((state) => state.user.demoDetails);
    const userData = useSelector((state) => state.user.user);


    useEffect(() => {
        const savedDemo = localStorage.getItem("demoData");
        if (savedDemo) {
            try {
                const parsedData = JSON.parse(savedDemo);
                dispatch(setDemoGraphyData(parsedData));
            } catch (error) {
                console.error("Error parsing demoData from localStorage:", error);
                localStorage.removeItem("demoData");


            }
        }
    }, [dispatch]);


    const { id } = useParams();
    const PatientID = localStorage.setItem("PatientID", id);
    var userPracticeID = userData ? userData.practiceID : null;

    var userId = userData ? userData.userID : null;

    const sAuthToken = useSelector((state) => state.user.token);
    const [userName, setuserName] = useState(DemoGraphyData?.username);
    const [passwordValue, setpasswordValue] = useState(DemoGraphyData?.password);
    const [firstName, setFirstName] = useState(DemoGraphyData?.FirstName || "");
    const [middleName, setmiddleName] = useState(DemoGraphyData?.MiddleName || "");
    const [lastname, setlastname] = useState(DemoGraphyData?.LastName || "");
    const [ssnValue, setssnValue] = useState(DemoGraphyData?.SSN || "");
    const [address1, setAddress1] = useState(DemoGraphyData?.Address1 || "");
    const [address2, setAddress2] = useState(DemoGraphyData?.Address2 || "");
    const [cityName, setcityName] = useState(DemoGraphyData?.CityName || "");
    const [state, setstate] = useState(DemoGraphyData?.StateName || "");
    const [cityNameID, setCityNameID] = useState("");
    const [stateID, setStateID] = useState("");
    const [zipCode, setzipCode] = useState(DemoGraphyData?.Zip || "");
    const [countryName, setcountryName] = useState(DemoGraphyData?.Country || "");
    const [titleValue, setTitleValue] = useState(DemoGraphyData?.Title || "0");
    const [genderValue, setGenderValue] = useState(DemoGraphyData?.Gender || "");
    const [maritalStatus, setMaritalStatus] = useState(DemoGraphyData?.MaritalStatusId || "0");
    const [raceValue, setraceValue] = useState(DemoGraphyData?.RaceId || "0");
    const [ethnicityValue, setEthnicityValue] = useState(DemoGraphyData?.EthnicGroupId || "0");
    const [languageMode, setLanguageMode] = useState(DemoGraphyData?.LanguageId || "0");
    const [preferredContact, setPreferredContact] = useState(DemoGraphyData?.PreferenceId || "0");
    const [reminderMode, setReminderMode] = useState(DemoGraphyData?.AppointmentRemMode || "0");
    const [homePhone, sethomePhone] = useState(DemoGraphyData?.HomeMainPhone || "");
    const [workPhone, setworkPhone] = useState(DemoGraphyData?.WorkMainPhone || "");
    const [cellPhone, setcellPhone] = useState(DemoGraphyData?.CellMainPhone || "");
    const [email, setEmail] = useState(DemoGraphyData?.Email1 || "");
    const [selectDOBDate, setSelectDOBDate] = useState(DemoGraphyData?.DOB || "");
    const [isDOBOpen, setIsDOBOpen] = useState(false);
    const [ethniCityData, setethniCityData] = useState([]);
    const [raceData, setRaceData] = useState([]);
    const [maritalStatusData, setmaritalStatusData] = useState([]);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successTimer, setSuccessTimer] = useState(5000);
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showSSN, setShowSSN] = useState(false);
    const [providerData, setproviderData] = useState([]);
    const [ProviderFName, setProviderFName] = useState("");
    const [providerLname, setProviderLname] = useState("");
    const [providerSpeciality, setProviderSpeciality] = useState("");
    const [providerNPI, setProviderNPI] = useState("");
    const [providerPhone, setProviderPhone] = useState("");
    const [providerFax, setProviderFax] = useState("");
    const [providerDate, setProviderDate] = useState("");
    const [startDate, setStartDate] = useState('');
    const [isStartOpen, setIsStartOpen] = useState(false);
    const [cityData, setcityData] = useState([]);
    const [countryData, setcountryData] = useState([]);
    const [languageData, setlanguageData] = useState([]);
    const [zipcodeData, setZipCodeData] = useState([]);
    const [zipError, setZipError] = useState("");


    const [emergencyContact, setEmergencyContact] = useState([]);

    const [errorMessages, setErrorMessages] = useState({
        cell: "",
        address: "",
        zip: "",
    });

   console.log("DEMODATA", DemoGraphyData);
   
    useEffect(() => {
  if (DemoGraphyData && Object.keys(DemoGraphyData).length > 0) {
    setuserName(DemoGraphyData?.username || "");
    setpasswordValue(DemoGraphyData?.password || "");
    setFirstName(DemoGraphyData?.FirstName || "");
    setmiddleName(DemoGraphyData?.MiddleName || "");
    setlastname(DemoGraphyData?.LastName || "");
    setssnValue(DemoGraphyData?.SSN || "");
    setAddress1(DemoGraphyData?.Address1 || "");
    setAddress2(DemoGraphyData?.Address2 || "");
    setCityNameID(DemoGraphyData?.CityName || "");
    setstate(DemoGraphyData?.StateName || "");
    setzipCode(DemoGraphyData?.Zip || "");
    setcountryName(DemoGraphyData?.Country || "");
    setTitleValue(DemoGraphyData?.Title || "0");
    setGenderValue(DemoGraphyData?.Gender || "");
    setMaritalStatus(DemoGraphyData?.MaritalStatusId || "0");
    setraceValue(DemoGraphyData?.RaceId || "0");
    setEthnicityValue(DemoGraphyData?.ethnicityId || "0");
    setLanguageMode(DemoGraphyData?.LanguageId || "0");
    setPreferredContact(DemoGraphyData?.AdditionalPreference1Id || "0");
    setReminderMode(DemoGraphyData?.AppointmentRemMode || "0");
    sethomePhone(DemoGraphyData?.HomeMainPhone || "");
    setworkPhone(DemoGraphyData?.WorkMainPhone || "");
    setcellPhone(DemoGraphyData?.CellMainPhone || "");
    setEmail(DemoGraphyData?.Email1 || "");
    setSelectDOBDate(DemoGraphyData?.DOB || "");
  }
}, [DemoGraphyData]);



    useEffect(() => {
        let timerId;


        if (showSuccessModal) {
            // Start the timer when the success modal is shown
            timerId = setTimeout(() => {
                setShowSuccessModal(false);

            }, successTimer);
        }


        return () => {
            clearTimeout(timerId);
        };
    }, [showSuccessModal, successTimer]);



    const handleDOBDateChange = (date) => {

        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setSelectDOBDate(formattedDate);

            setIsDOBOpen(false)

        } else {
            setSelectDOBDate(null);
        }
    };



    const CalendarDOBContainer = ({ children, id }) => (
        <div style={{ zIndex: '99', backgroundColor: 'white', border: '1px solid lightgray' }}>
            {children}
            <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
                <button type="button" className='today-btn' onClick={() => handleTodayClick("dob")}>
                    Today
                </button>
            </div>
        </div>
    );




    const getMonths = (selectedYear) => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();

        return Array.from({ length: 12 }, (v, k) => {
            if (selectedYear === currentYear && k > currentMonth) {
                return null;
            }
            return (
                <option key={k} value={k}>
                    {format(new Date(selectedYear, k), 'MMMM')}
                </option>
            );
        }).filter(option => option !== null);
    };




    const handleTodayClick = (dateType) => {
        const today = new Date();


        if (dateType === "dob" && selectDOBDate) {
            setSelectDOBDate(today);
            setIsDOBOpen(false);
        }
    }





    const handleStartDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setStartDate(formattedDate);
            setIsStartOpen(false)

        } else {
            setStartDate(null);
        }
    };




    const CalendarStartContainer = ({ children }) => (
        <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
            {children}
            <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
                <button type="button" className='today-btn' onClick={() => handleTodayClick("start")}>
                    Today
                </button>

            </div>
        </div>
    );


    const formatPhoneNumber = (value) => {
        const cleaned = value.replace(/\D/g, '').slice(0, 10);
        const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
        if (!match) return value;
        const [, area, prefix, line] = match;
        let result = '';
        if (area) result = `(${area}`;
        if (prefix) result += `) ${prefix}`;
        if (line) result += `-${line}`;
        return result;
    };


    const handlePhoneInputChange = (e) => {
        const raw = e.target.value.replace(/\D/g, '');

        if (raw.length <= 10) {
            sethomePhone(formatPhoneNumber(raw));

            if (raw.length < 10) {
                setErrorMessages((prev) => ({
                    ...prev,
                    homephone: 'Phone number must be 10 digits',
                }));
            } else {
                setErrorMessages((prev) => ({ ...prev, homephone: '' }));
            }

        } else {
            setErrorMessages((prev) => ({
                ...prev,
                homephone: 'Phone number must be 10 digits',
            }));
        }
    };


    const handleWorkPhoneInputChange = (e) => {
        const raw = e.target.value.replace(/\D/g, '');

        if (raw.length <= 10) {
            setworkPhone(formatPhoneNumber(raw));

            if (raw.length < 10) {
                setErrorMessages((prev) => ({
                    ...prev,
                    workphone: 'Phone number must be 10 digits',
                }));
            } else {
                setErrorMessages((prev) => ({ ...prev, workphone: '' }));
            }

        } else {
            setErrorMessages((prev) => ({
                ...prev,
                workphone: 'Phone number must be 10 digits',
            }));
        }
    };



    const handleCellPhoneInputChange = (e) => {
        const raw = e.target.value.replace(/\D/g, '');

        if (raw.length <= 10) {
            setcellPhone(formatPhoneNumber(raw));

            if (raw.length < 10) {
                setErrorMessages((prev) => ({
                    ...prev,
                    cell: 'Phone number must be 10 digits',
                }));
            } else {
                setErrorMessages((prev) => ({ ...prev, cell: '' }));
            }

        } else {
            setErrorMessages((prev) => ({
                ...prev,
                cell: 'Phone number must be 10 digits',
            }));
        }
    };


    const handleProviderPhoneInputChange = (e) => {
        const raw = e.target.value.replace(/\D/g, '');

        if (raw.length <= 10) {
            setProviderPhone(formatPhoneNumber(raw));

            if (raw.length < 10) {
                setErrorMessages((prev) => ({
                    ...prev,
                    providerphone: 'Phone number must be 10 digits',
                }));
            } else {
                setErrorMessages((prev) => ({ ...prev, providerphone: '' }));
            }

        } else {
            setErrorMessages((prev) => ({
                ...prev,
                providerphone: 'Phone number must be 10 digits',
            }));
        }
    };



    const handleGetMasterEthnicity = async () => {
        const url = `${APIConstants.COMMON_BASE_URL}${PatientDMTabConstants.GetMasterEthnicity}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {

                const parsedData = JSON.parse(data)
                setethniCityData(parsedData)

            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }


    const handleGetMasterRace = async () => {



        const url = `${APIConstants.COMMON_BASE_URL}${PatientDMTabConstants.GetMasterRace}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {

                const parsedData = JSON.parse(data)
                setRaceData(parsedData)

            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }


    const handleGetMasterMaritalStatus = async () => {

        const url = `${APIConstants.COMMON_BASE_URL}${PatientDMTabConstants.GetMasterMaritalStatus}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {

                const parsedData = JSON.parse(data)
                setmaritalStatusData(parsedData)

            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }



    const handlePatientConsultedPhyDetails = async () => {

        const url = `${APIConstants.PATIENT_PORTAL_URL}${PatientDMTabConstants.GetPatientConsultedPhyDetails}?sInputJSON={PatientId:${id}}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {

                const parsedData = JSON.parse(data)
                setproviderData(parsedData)

            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }


    const handleGetEmergencyCotactDetails = async () => {

        const url = `${APIConstants.PATIENT_PORTAL_URL}${PatientDMTabConstants.GetEmergencyCotactDetails}?sInputJSON={PatientId:${id}}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {

                const parsedData = JSON.parse(data)
                setEmergencyContact(parsedData)

            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }



    const handleGetZipCode = async (zip) => {

        if (!zipCode.trim()) {
            setZipError("");
            setZipCodeData(null);
            return;
        }

        if (!/^\d{5}$/.test(zip)) {
            setZipError("Zip code must be exactly 5 digits");
            setZipCodeData(null);
            return;
        }

        setZipError("");

        try {
            const url = `${APIConstants.PATIENT_PORTAL_URL}${PatientDMTabConstants.GetZipCode}?sInputJSON={ZipCode:${zip}}`;

            const response = await fetch(url, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                console.error("Error fetching ZIP:", response.status);
                return;
            }

            const data = await response.json();
            const parsedData = JSON.parse(data);
            if (!data || data.length === 0) {
                setZipError("Incorrect Zipcode");
                setZipCodeData(null);
                return;
            }


            setZipError("");

            console.log("ZIPDATA:", parsedData);
            setZipCodeData(parsedData);
            setcityName(parsedData.City)
            setcountryName(parsedData.Country)
            setstate(parsedData.State)
            setCityNameID(parsedData.CityID)
            setStateID(parsedData.StateID)

        } catch (error) {
            console.error("Error fetching ZIP data:", error);
            setZipError("");
        }
    };


    useEffect(() => {
        if (zipCode.length === 5) {
            const timeout = setTimeout(() => {
                handleGetZipCode(zipCode);
            }, 500);
            return () => clearTimeout(timeout);
        } else {
            setZipCodeData(null);
        }
    }, [zipCode]);

    const handleGetCityData = async () => {

        const url = `${APIConstants.COMMON_BASE_URL}${PatientDMTabConstants.GetCityData}?sInputJSON={}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {

                const parsedData = JSON.parse(data)
                console.log("CITYDATA??????????", parsedData);
                setcityData(parsedData)

            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }


    const handleGetCountriesData = async () => {

        const url = `${APIConstants.BASE_URL_PRACTICE_API}${PatientDMTabConstants.GetCountriesData}?sInputJSON={}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {

                const parsedData = JSON.parse(data)
                console.log("COUDATA??????????", parsedData);
                setcountryData(parsedData)

            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }


    const handleGetLanguages = async () => {

        const url = `${APIConstants.BASE_URL_PRACTICE_API}${PatientDMTabConstants.GetLanguages}?sInputJSON={}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {

                const parsedData = JSON.parse(data)
                setlanguageData(parsedData)
            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }




    useEffect(() => {

        handleGetMasterEthnicity();
        handleGetMasterRace();
        handleGetMasterMaritalStatus();
        handlePatientConsultedPhyDetails();
        handleGetEmergencyCotactDetails();
        handleGetCityData();
        handleGetCountriesData();
        handleGetLanguages();
        handleGetZipCode();

    }, []);



    const handleUpdatePersonalInformation = async () => {

        setLoading(true);

        const inpuJson = {
            PatientId: id,
            password: passwordValue || "",
            username: userName || "",
            Title: titleValue || "",
            fNameEncrypt: firstName || "",
            lNameEncryt: lastname || "",
            mNameEncrypt: middleName || "",
            dobEncrypt: formatDOSDate(selectDOBDate) || "",
            Gender: genderValue || "",
            SSNEncrypt: ssnValue || "",
            MaritalStatusId: maritalStatus || "",
            RaceId: raceValue || "",
            ethnicityId: ethnicityValue || "",
            PracticeID: userPracticeID,
            IsDefaultPract: 0

        }




        const myInput = JSON.stringify(inpuJson);
        const inputData = JSON.stringify(myInput)


        try {
            const response = await fetch(APIConstants.PATIENT_PORTAL_URL + PatientDMTabConstants.UpdatePersonalInformation, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',

                },
                body: inputData
            })



            if (response.status !== 200) {
                console.log("Error: Received response status", response.status);
                return;
            }



            const responseData = await response.json();

            setTimeout(() => {
                setLoading(false);

            }, 100);

            console.log("RESPONSE??????", responseData);

            if (responseData > 0) {

                setShowSuccessModal(true)
            }




        } catch (error) {
            console.error('An error occurred:', error);
        }
    };



    const handleSavePatientAddressDetails = async () => {
        setLoading(true)

        const inpuJson = {
            Add1Encrypt: id,
            City: cityNameID || "",
            State: stateID || "",
            cityNameEncrypt: '',
            statNameEncrypt: '',
            ssnEncrypt: '',
            countryName: countryName || "",
            Add2Encrypt: '',
            ZipCode: zipCode || "",
            CountryID: "",
            PatientId: id

        }

        const myInput = JSON.stringify(inpuJson);
        const inputData = JSON.stringify(myInput)


        try {
            const response = await fetch(APIConstants.PATIENT_PORTAL_URL + PatientDMTabConstants.SavePatientAddressDetails, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',

                },
                body: inputData
            })



            if (response.status !== 200) {
                console.log("Error: Received response status", response.status);
                return;
            }



            const responseData = await response.json();

            setTimeout(() => {
                setLoading(false);

            }, 100);

            console.log("RESPONSE??????", responseData);

            if (responseData > 0) {

                setShowSuccessModal(true)
            }


        } catch (error) {
            console.error('An error occurred:', error);
            setLoading(false);
        }
    };



    const handleSavePatientContactDetails = async () => {
        setLoading(true);


        const inpuJson = {
            HomeMainPhoneEncrypt: homePhone || "",
            cellmainEncrypt: cellPhone || "",
            emailEncrypt: email || "",
            language: languageMode || "",
            appReminderMode: reminderMode || "",
            preference: preferredContact || "",
            workmainphoneEncrypt: workPhone || "",
            PatientId: id

        }

        const myInput = JSON.stringify(inpuJson);
        const inputData = JSON.stringify(myInput)


        try {
            const response = await fetch(APIConstants.PATIENT_PORTAL_URL + PatientDMTabConstants.SavePatientContactDetails, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',

                },
                body: inputData
            })



            if (response.status !== 200) {
                console.log("Error: Received response status", response.status);
                return;
            }



            const responseData = await response.json();

            setTimeout(() => {
                setLoading(false);

            }, 100);

            if (responseData > 0) {
                setShowSuccessModal(true)

            }




        } catch (error) {
            console.error('An error occurred:', error);
        }
    };


    const handleSavePCPPhysician = async () => {
        setLoading(true);

        const inpuJson = {
            FirstName: ProviderFName || "",
            LastName: providerLname || "",
            NPI: providerNPI || "",
            ProviderSpl: providerSpeciality || "",
            PhyPhone: providerPhone || "",
            PhyFax: providerFax || "",
            addedDate: startDate || "",
            PhyType: '',
            PatientID: id

        }

        const myInput = JSON.stringify(inpuJson);
        const inputData = JSON.stringify(myInput);


        try {
            const response = await fetch(APIConstants.PATIENT_PORTAL_URL + PatientDMTabConstants.SavePCPPhysician, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',

                },
                body: inputData
            })



            if (response.status !== 200) {
                console.log("Error: Received response status", response.status);
                return;
            }



            const responseData = await response.json();

            setTimeout(() => {
                setLoading(false);

            }, 100);

            if (responseData > 0) {
                setShowSuccessModal(true)

            }


        } catch (error) {
            console.error('An error occurred:', error);
        }
    };




    useEffect(() => {
        if (providerData) {
            setProviderFName(providerData.FirstName || "");
            setProviderLname(providerData.LastName || "");
            setProviderSpeciality(providerData.Speciality || "");
            setProviderNPI(providerData.NPI || "");
            setProviderPhone(providerData.PhyPhone || "");
            setProviderFax(providerData.PhyFax || "");
            setStartDate(providerData.addedDate || "");
        }
    }, [providerData]);


    const handleCloseModals = () => {
        // Close all modals

        setShowSuccessModal(false)

    };


    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    const handleToggleSSN = () => {
        setShowSSN(!showSSN);
    };



    const formatSSN = (value) => {
        const numericValue = value.replace(/\D/g, ""); // remove non-digits
        if (numericValue.length <= 3) return numericValue;
        if (numericValue.length <= 5)
            return `${numericValue.slice(0, 3)}-${numericValue.slice(3)}`;
        return `${numericValue.slice(0, 3)}-${numericValue.slice(3, 5)}-${numericValue.slice(5, 9)}`;
    };

    const handleSSNChange = (e) => {
        const formatted = formatSSN(e.target.value);
        setssnValue(formatted);



        if (!DemoGraphyData || Object.keys(DemoGraphyData).length == 0) {
            return <div>Loading...</div>;
        }
    };

    return (
        <>

            <div style={{ width: '100%', margin: '5px', padding: '5px', border: "1px solid blue" }}>


                {loading && (
                    <div className="overlay">
                        <div className="spinner-container">
                            <div className="spinner-grow text-danger" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <div className="spinner-grow text-warning" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <div className="spinner-grow text-info" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                )}



                <table className='table-border border border-white' style={{ width: '100%', margin: '2px', fontSize: '1.2rem', padding: '5px' }}>
                    <tbody><tr >
                        <td height="25" align="center" colSpan="4" valign="middle" width="100%" className="topnavmenu text-center mt-4">
                            <label tyle={{ fontSize: '1.2rem', marginTop: '15px', textAlign: 'center', textTransform: 'uppercase' }}>Personal Information</label>
                        </td>
                    </tr>
                        <tr className="rows">
                            <td width="18%">Title :
                            </td>
                            <td style={{ width: '30%' }}>
                                <select tabIndex="50" className="textboxes" style={{ width: '150px' }}
                                    value={titleValue}
                                    onChange={(e) => setTitleValue(e.target.value)}
                                >
                                    <option value="0">&lt;--Select--&gt;</option>
                                    <option value="1">Dr.</option>
                                    <option value="3">Miss.</option>
                                    <option value="2">Mr.</option>
                                    <option value="4">Mrs.</option>
                                    <option value="6">Ms.</option>
                                    <option value="9">Other</option>
                                    <option value="7">Prof</option>

                                </select>
                            </td>
                            <td style={{ width: '20%' }} valign="middle">
                                <table width="100%">
                                    <tbody><tr>

                                        <td align="left">DOB :<span style={{ color: 'red' }}>*</span>
                                        </td>
                                    </tr>
                                    </tbody></table>
                            </td>
                            <td>
                                <DatePicker
                                    selected={selectDOBDate ? new Date(selectDOBDate) : ""}
                                    onChange={handleDOBDateChange}
                                    dateFormat="MM/dd/yyyy"
                                    maxDate={new Date()}
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    yearDropdownItemNumber={100}
                                    className={`clnImgTextBoxes ${selectDOBDate ? 'default-selected' : ''}`}
                                    placeholderText="MM/dd/yyyy"
                                    popperPlacement="bottom-start"

                                    calendarContainer={CalendarDOBContainer}
                                    open={isDOBOpen}
                                    onFocus={() => setIsDOBOpen(true)}
                                    onInputClick={() => setIsDOBOpen(true)}
                                    onClickOutside={() => setIsDOBOpen(false)}
                                    renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                                        const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                                        const selectedMonth = selectedDate.getMonth();
                                        const selectedYear = selectedDate.getFullYear();

                                        return (
                                            <div>
                                                <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                                                    {"<"}
                                                </button>
                                                <select
                                                    value={selectedMonth}
                                                    onChange={({ target: { value } }) => changeMonth(Number(value))}
                                                >
                                                    {getMonths(selectedYear)}
                                                </select>
                                                <select
                                                    value={selectedYear}
                                                    onChange={({ target: { value } }) => changeYear(Number(value))}
                                                >
                                                    {Array.from({ length: 100 }, (v, k) => (
                                                        <option key={k} value={new Date().getFullYear() - k}>
                                                            {new Date().getFullYear() - k}
                                                        </option>
                                                    ))}
                                                </select>
                                                <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                                                    {">"}
                                                </button>
                                            </div>
                                        );
                                    }}
                                />
                                <span className="validationMessages" style={{ display: 'none' }}>Please select DOB</span>
                            </td>
                        </tr>
                        <tr className="rowsAlt">
                            <td>First Name :<span style={{ color: 'red' }}>*</span>
                            </td>
                            <td>
                                <input type="text" maxLength="100" tabIndex="2" className="textboxes validatedinput" style={{ width: '150px' }} autocomplete="1757918663046_25"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                />
                                <span className="validationMessages" style={{ visibility: 'hidden' }}>Please enter firstname</span>
                                <span style={{ color: 'red', display: 'none' }}>First name should be characters only</span>
                            </td>
                            <td>Gender :
                            </td>
                            <td align="left">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <input
                                                    type="radio"
                                                    value="1"
                                                    checked={genderValue === "Male" || genderValue === "1" }
                                                    onChange={(e) => setGenderValue(e.target.value)}
                                                    tabIndex="6"
                                                />
                                                <label>Male</label>
                                            </td>
                                            <td>
                                                <input
                                                    type="radio"
                                                    value="2"
                                                    checked={genderValue === "Female" || genderValue === "2" }
                                                    onChange={(e) => setGenderValue(e.target.value)}
                                                    tabIndex="6"
                                                />
                                                <label>Female</label>
                                            </td>
                                            <td>
                                                <input
                                                    type="radio"
                                                    value="3"
                                                    checked={genderValue === "Unknown" || genderValue === "3" }
                                                    onChange={(e) => setGenderValue(e.target.value)}
                                                    tabIndex="6"
                                                />
                                                <label>Unknown</label>
                                            </td>
                                        </tr>

                                    </tbody></table>
                                <span className="validationMessages" style={{ display: 'none' }}>Select Gender</span>
                            </td>
                        </tr>
                        <tr className="rows">
                            <td>Middle Name :
                            </td>
                            <td>
                                <input tabIndex="3" className="textboxes validatedinput" style={{ width: '150px' }}
                                    value={middleName}
                                    onChange={(e) => setmiddleName(e.target.value)}
                                />
                                <span style={{ color: 'red', display: 'none' }}>Middle name should be characters only</span>
                            </td>
                            <td>SSN :
                            </td>
                            <td>
                                <input type={showSSN ? 'text' : 'password'} className="textboxes validatedinput" style={{ width: '150px' }}
                                    maxLength={11}
                                    value={ssnValue}
                                    onChange={handleSSNChange}
                                />
                                <i className="" aria-hidden="true" id="iSSNIndicator" style={{ color: 'palevioletred' }} title=""></i>
                                <FontAwesomeIcon className='fa'
                                    icon={showSSN ? faEye : faEyeSlash}
                                    aria-hidden="true"
                                    onClick={handleToggleSSN}
                                    style={{ cursor: 'pointer', color: 'black' }}
                                />
                            </td>

                        </tr>
                        <tr className="rowsAlt">
                            <td>Last Name :<span style={{ color: 'red' }}>*</span>
                            </td>
                            <td>
                                <input type="text" tabIndex="4" className="textboxes validatedinput" style={{ width: '150px' }}
                                    value={lastname}
                                    onChange={(e) => setlastname(e.target.value)}
                                />
                                <span className="validationMessages" style={{ visibility: 'hidden' }}>Please enter lastname</span>
                                <span style={{ color: 'red', display: 'none' }}>Last name should be characters only</span>
                            </td>

                            <td>Marital Status</td>
                            <td>
                                <select className="textboxes" style={{ width: '150px' }}
                                    value={maritalStatus}
                                    onChange={(e) => setMaritalStatus(e.target.value)}
                                >
                                    <option value="" >
                                        &lt;--Select--&gt;
                                    </option>
                                    {maritalStatusData.map((item, index) => (
                                        <option value={item.MaritalId} key={index}>{item.MaritalStatus}</option>
                                    ))}



                                </select>
                            </td>
                        </tr>
                        <tr className="rows">
                            <td>Race
                            </td>
                            <td>
                                <select className="textboxes" style={{ width: '150px' }}
                                    value={raceValue}
                                    onChange={(e) => setraceValue(e.target.value)}
                                >
                                    <option value="" >
                                        &lt;--Select--&gt;
                                    </option>
                                    {raceData.map((item, index) => (
                                        <option value={item.RaceId} key={index}>{item.Race}</option>
                                    ))}


                                </select>
                            </td>
                            <td>Ethnicity
                            </td>
                            <td>
                                <select className="textboxes" style={{ width: '150px' }}
                                    value={ethnicityValue}
                                    onChange={(e) => setEthnicityValue(e.target.value)}
                                >
                                    <option value="" >
                                        &lt;--Select--&gt;
                                    </option>
                                    {ethniCityData.map((item, index) => (
                                        <option value={item.EnId} key={index}>{item.Ethnicity}</option>
                                    ))}

                                </select>
                            </td>
                        </tr>
                        <tr className="rowsAlt">
                            <td>Username :</td>
                            <td>
                                <input type="text" readOnly="readonly"
                                    value={userName}
                                    onChange={(e) => setuserName(e.target.value)}
                                /></td>
                            <td>Password :</td>
                            <td>
                                <input type={showPassword ? 'text' : 'password'} className="textboxes"
                                    value={passwordValue}
                                    onChange={(e) => setpasswordValue(e.target.value)}
                                />

                                <FontAwesomeIcon className='fa'
                                    icon={showPassword ? faEye : faEyeSlash}
                                    aria-hidden="true"
                                    onClick={handleTogglePassword}
                                    style={{ cursor: 'pointer', color: 'black' }}
                                />

                            </td>
                        </tr>
                        <tr className="rows">
                            <td colSpan="4" align="right" className="bottomButtons">
                                <input onClick={handleUpdatePersonalInformation} type="submit" value="Save" class="but" />
                            </td>
                        </tr>
                    </tbody>
                </table>



                <table style={{ width: '100%', margin: '4px', fontSize: '1.2rem' }}>
                    <tbody><tr >
                        <td height="25" align="center" colSpan="4" valign="middle" width="100%" className="topnavmenu text-center mt-4">
                            <label tyle={{ fontSize: '1.2rem', marginTop: '15px', textAlign: 'center', textTransform: 'uppercase' }}>Address Information</label>
                        </td>
                    </tr>

                        <tr className="rowsAlt">
                            <td>Address 1 :<span style={{ color: 'red' }}>*</span>
                            </td>
                            <td>
                                <input type="text" maxLength="100" tabIndex="2" className="textboxes validatedinput" style={{ width: '150px' }}
                                    value={address1}
                                    onChange={(e) => setAddress1(e.target.value)}
                                />

                            </td>

                            <td onClick={handleGetLanguages}>City :<span style={{ color: 'red' }}>*</span>
                            </td>
                            <td>
                                <input type="text" maxLength="100" tabIndex="2" className="textboxes validatedinput" style={{ width: '150px' }}
                                    value={cityName}
                                    onChange={(e) => handleGetCityData(e.target.value)}
                                />
                                <span className="validationMessages" style={{ visibility: 'hidden' }}></span>
                                <span style={{ color: 'red', display: 'none' }}></span>
                            </td>

                        </tr>
                        <tr className="rows">
                            <td>Address 2 :
                            </td>
                            <td>
                                <input type="text" tabIndex="3" className="textboxes validatedinput" style={{ width: '150px' }}
                                    value={address2}
                                    onChange={(e) => setAddress2(e.target.value)}
                                />

                            </td>
                            <td>State :
                            </td>
                            <td>
                                <input type="text" tabIndex="9" className="textboxes validatedinput" style={{ width: '150px' }}
                                    value={state}
                                    onChange={(e) => setstate(e.target.value)}
                                />

                            </td>
                        </tr>
                        <tr className="rowsAlt">
                            <td>Zip Code :<span style={{ color: 'red' }}>*</span>
                            </td>
                            <td>
                                <input type="text" style={{ width: '150px' }}
                                    value={zipCode}
                                    maxLength={5}
                                    onChange={(e) => setzipCode(e.target.value)}
                                    onBlur={handleGetZipCode}
                                />
                                {zipError && (
                                    <span
                                        className="validationMessages"
                                        style={{ color: "red", display: "block", marginTop: "5px", fontSize: '0.9rem' }}
                                    >
                                        {zipError}
                                    </span>
                                )}

                            </td>


                            <td>Country :
                            </td>
                            <td>
                                <input type="text" maxLength="11" className="textboxes validatedinput" style={{ width: '150px' }}
                                    value={countryName}
                                    onChange={(e) => setcountryName(e.target.value)}
                                />

                            </td>


                        </tr>


                        <tr className="rows">
                            <td colSpan="4" align="right" className="bottomButtons">
                                <input type="submit" value="Save" onClick={handleSavePatientAddressDetails} class="but" />
                            </td>
                        </tr>
                    </tbody>
                </table>


                <table style={{ width: '100%', margin: '4px', fontSize: '1.2rem' }}>
                    <tbody><tr >
                        <td height="25" align="center" colSpan="4" valign="middle" width="100%" className="topnavmenu text-center mt-4">
                            <label tyle={{ fontSize: '1.2rem', marginTop: '15px', textAlign: 'center', textTransform: 'uppercase' }}>Contact Information</label>
                        </td>
                    </tr>

                        <tr className="rowsAlt">
                            <td>Preferred Contact Number :<span style={{ color: 'red' }}>*</span>
                            </td>
                            <td style={{ width: '30%' }}>
                                <select tabIndex="50" className="textboxes" style={{ width: '150px' }}
                                    value={preferredContact}
                                    onChange={(e) => setPreferredContact(e.target.value)}
                                >
                                    <option value="0">&lt;--Select--&gt;</option>
                                    <option value="1">Home Phone</option>
                                    <option value="2">Cell Phone</option>


                                </select>
                            </td>

                            <td>Appointment Reminder Mode :<span style={{ color: 'red' }}>*</span>
                            </td>
                            <td style={{ width: '30%' }}>
                                <select tabIndex="50" className="textboxes" style={{ width: '150px' }}
                                    value={reminderMode}
                                    onChange={(e) => setReminderMode(e.target.value)}
                                >
                                    <option value="0">&lt;--Select--&gt;</option>
                                    <option value="1">Voice Call</option>
                                    <option value="2">SMS</option>
                                    <option value="3">Email</option>


                                </select>
                            </td>

                        </tr>
                        <tr className="rows">
                            <td>Home Phone:
                            </td>
                            <td>
                                <input type="text" tabIndex="3" className="textboxes validatedinput" style={{ width: '150px' }}
                                    value={homePhone}
                                    onChange={handlePhoneInputChange}
                                    maxLength={14}
                                />
                                {errorMessages.homephone && (
                                    <div className="text-red-500 text-sm">{errorMessages.homephone}</div>
                                )}
                            </td>
                            <td>Work Phone :
                            </td>
                            <td>
                                <input type="text" tabIndex="9" className="textboxes validatedinput" style={{ width: '150px' }}
                                    value={workPhone}
                                    onChange={handleWorkPhoneInputChange}
                                    maxLength={14}
                                />

                                {errorMessages.workphone && (
                                    <div className="text-red-500 text-sm">{errorMessages.workphone}</div>
                                )}

                            </td>

                        </tr>
                        <tr className="rowsAlt">
                            <td>Cell Phone :<span style={{ color: 'red' }}>*</span>
                            </td>
                            <td>
                                <input type="text" tabIndex="4" className="textboxes validatedinput" style={{ width: '150px' }}
                                    value={cellPhone}
                                    onChange={handleCellPhoneInputChange}
                                    maxLength={14}
                                />

                                {errorMessages.cell && (
                                    <div className="text-red-500 text-sm">{errorMessages.cell}</div>
                                )}

                            </td>


                            <td>Email  :
                            </td>
                            <td>
                                <input type="email" tabIndex="9" className="textboxes validatedinput" style={{ width: '150px' }}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </td>


                        </tr>


                        <tr className="rowsAlt">

                            <td width="18%">Preferred Language :
                            </td>
                            <td style={{ width: '30%' }}>
                                <select tabIndex="50" className="textboxes" style={{ width: '150px' }}
                                    value={languageMode}
                                    onChange={(e) => setLanguageMode(e.target.value)}
                                >

                                    <option value="">
                                        &lt;--Select--&gt;
                                    </option>
                                    {languageData.map((item, index) => (
                                        <option value={item.LanID} key={index}>{item.Language}</option>
                                    ))}

                                </select>
                            </td>



                            <td width="18%">Photo ID :
                            </td>
                            <td style={{ width: '30%' }}>
                                <input type="submit" value="Picture" class="but" />
                            </td>

                        </tr>

                        <tr className="rows">
                            <td colSpan="4" align="right" className="bottomButtons">
                                <input type="submit" value="Save" onClick={handleSavePatientContactDetails} class="but" />
                            </td>
                        </tr>
                    </tbody>
                </table>



                <div className='topnavmenu text-center'>
                    <label style={{ fontSize: '1.2rem', marginTop: '5px', textAlign: 'center' }} onClick={handleGetEmergencyCotactDetails}> Provider Information</label>
                </div>


                <table className="table table-hover table-striped table-bordered mb-0">
                    <thead>

                        <tr className='align-top' >

                            <th style={{ backgroundColor: '#0173b7', color: 'white' }}>Date Consulted</th>
                            <th style={{ backgroundColor: '#0173b7', color: 'white' }}>
                                First Name
                            </th>
                            <th style={{ backgroundColor: '#0173b7', color: 'white' }}>Last Name

                            </th>

                            <th style={{ backgroundColor: '#0173b7', color: 'white' }}>Speciality

                            </th>


                            <th style={{ backgroundColor: '#0173b7', color: 'white' }}>NPI


                            </th>
                            <th style={{ backgroundColor: '#0173b7', color: 'white' }}>Phone

                            </th>

                            <th style={{ backgroundColor: '#0173b7', color: 'white' }}>Fax

                            </th>


                        </tr>


                    </thead>

                    <tbody>

                        <tr>
                            <td>

                                <DatePicker
                                    selected={startDate ? new Date(startDate) : null}
                                    onChange={handleStartDateChange}
                                    dateFormat="MM/dd/yyyy"
                                    maxDate={new Date()}
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    yearDropdownItemNumber={100}

                                    className={`clnImgTextBoxes ${startDate ? 'default-selected' : ''}`}
                                    placeholderText="MM/dd/yyyy"

                                    calendarContainer={CalendarStartContainer}
                                    open={isStartOpen}
                                    onFocus={() => setIsStartOpen(true)}
                                    onInputClick={() => setIsStartOpen(true)}
                                    onClickOutside={() => setIsStartOpen(false)}
                                    renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                                        const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                                        const selectedMonth = selectedDate.getMonth();
                                        const selectedYear = selectedDate.getFullYear();

                                        return (
                                            <div>
                                                <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '50px' }}>
                                                    {"<"}
                                                </button>
                                                <select
                                                    value={selectedMonth}
                                                    onChange={({ target: { value } }) => changeMonth(Number(value))}
                                                >
                                                    {getMonths(selectedYear)}
                                                </select>
                                                <select
                                                    value={selectedYear}
                                                    onChange={({ target: { value } }) => changeYear(Number(value))}
                                                >
                                                    {Array.from({ length: 100 }, (v, k) => (
                                                        <option key={k} value={new Date().getFullYear() - k}>
                                                            {new Date().getFullYear() - k}
                                                        </option>
                                                    ))}
                                                </select>
                                                <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '50px' }}>
                                                    {">"}
                                                </button>
                                            </div>
                                        );
                                    }}
                                />

                            </td>
                            <td>
                                <input type="text" style={{ width: '150px' }}
                                    value={ProviderFName}
                                    onChange={(e) => setProviderFName(e.target.value)}
                                />
                            </td>
                            <td>
                                <input type="text" style={{ width: '150px' }}
                                    value={providerLname}
                                    onChange={(e) => setProviderLname(e.target.value)}
                                />
                            </td>

                            <td>
                                <input type="text" style={{ width: '150px' }}
                                    value={providerSpeciality}
                                    onChange={(e) => setProviderSpeciality(e.target.value)}
                                />
                            </td>

                            <td>
                                <input type="text" maxLength="11" style={{ width: '150px' }}
                                    value={providerNPI}
                                    onChange={(e) => setProviderNPI(e.target.value)}
                                />
                            </td>

                            <td>
                                <input type="text" tabIndex="4" style={{ width: '150px' }}
                                    value={providerPhone}
                                    onChange={handleProviderPhoneInputChange}
                                    maxLength={14}
                                />

                                {errorMessages.providerphone && (
                                    <div className="text-red-500 text-sm">{errorMessages.providerphone}</div>
                                )}
                            </td>

                            <td>
                                <input />
                            </td>
                        </tr>

                        <tr className="rows">
                            <td colSpan="8" align="right" className="bottomButtons">
                                <input type="submit" value="Save" class="but" onClick={handleSavePCPPhysician} />
                            </td>
                        </tr>

                    </tbody>



                </table>



                {showSuccessModal && (
                    <div className='alert-modal'>
                        <label></label>
                        <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                        <p>Records Updated Successfully!!</p>

                    </div>
                )}


            </div>

        </>

    )
}


export default PatPersonalInfo


